Namespace 'Customer.Dashboard'

class Customer.Dashboard.TicketSummaryEmailAuthorView extends Backbone.View
  template: JST['backbone/templates/customer/dashboard/summary/main/body/ticket_summary_email_author']
  className: 'summary-email'

  initialize: ({ticketSummary}) ->
    @ticketSummary = ticketSummary

  render: ->
    @$el.html @template
      from: @_getFrom()
      to: @_getTo()
      nameColor: @_nameColor()
    @

  _nameColor: ->
    window.color_for @ticketSummary.get('sub_type')

  _getFrom: ->
    @ticketSummary.get('email_summary').from

  _getTo: ->
    @ticketSummary.get('email_summary').to?.join(', ')
